<div class="login-modal">
  <header class="modal__header">
    <h2 [ngStyle]="color && { color: 'black' }" id="modalLabel">{{ 'user.label.login_to_airmiles' | translate }}</h2>
    <button
      type="button"
      class="button modal__button--close"
      (click)="closeModal(true, true)"
      [attr.aria-label]="'general.label.close' | translate"
    >
      <i class="icon icon-ui-close--sm" [ngStyle]="color && { 'background-color': '#' + color.color }"></i>
    </button>
  </header>
  <div class="modal__content">
    <air-form
      #formComponent
      [controls]="form"
      [alternateReCaptchaActions]="[reCaptchaAction]"
      [userEventSource]="userEventSource"
      (submitted)="submitValues($event)"
    >
      @if (partnerNotice) {
        <p class="login-modal__partner-notice" [internalInnerHtml]="partnerNotice" [userEventSource]="userEventSource"></p>
      }

      <div class="button__group--column">
        <button
          type="submit"
          class="button form__button button--cta"
          [class.button--disabled]="formDisabled"
          [ngStyle]="color && { 'background-color': '#' + color.color }"
          [airButtonLoading]="isSubmitting"
          [disabled]="formDisabled"
          (click)="submit($event)"
        >
          <span>{{ 'user.label.login' | translate }}</span>
        </button>
        <button
          type="button"
          class="button button--secondary"
          [ngStyle]="color && { color: '#' + color.color }"
          (click)="openPasswordResetModal($event)"
        >
          <span>{{ 'user.label.cannot_login' | translate }}</span>
        </button>
        @if (!alternateMode) {
          <hr />
          <button type="button" class="button button--border" (click)="goToRegistrationPage($event, false)">
            <span>{{ 'user.label.register' | translate }}</span>
          </button>
          <button type="button" class="button button--secondary" (click)="goToRegistrationPage($event, true)">
            <span>{{ 'user.label.register_card' | translate }}</span>
          </button>
        }
      </div>
    </air-form>
  </div>
</div>
